import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { LoadDiskAdminAuditTask } from '../Tasks/LoadDiskAdminAuditTask'

import type { DiskAdminAuditEntry, DiskAdminAuditFilter } from '../Contracts/DiskAdmin'

export const AUDIT_PAGE_SIZE = 25

export const EMPTY_AUDIT_FILTER: DiskAdminAuditFilter = { from: null, to: null, actor: null, event: null, storage: null }

/** Журнал адміністратора (`DISK-006` §2.4): фільтри й сторінки, лише читання. */
export class DiskAdminAuditStore {
    filter: DiskAdminAuditFilter = { ...EMPTY_AUDIT_FILTER }
    page = 1
    items: DiskAdminAuditEntry[] = []
    total = 0
    isLoading = false
    error: string | null = null

    private requestId = 0

    constructor() {
        makeAutoObservable<DiskAdminAuditStore, 'requestId'>(this, { requestId: false })
    }

    get hasFilter(): boolean {
        return Object.values(this.filter).some((value) => value !== null && value !== '')
    }

    setFilter(patch: Partial<DiskAdminAuditFilter>): void {
        this.filter = { ...this.filter, ...patch }
        this.page = 1
        void this.load()
    }

    resetFilter(storage: string | null = null): void {
        this.filter = { ...EMPTY_AUDIT_FILTER, storage }
        this.page = 1
        void this.load()
    }

    setPage(page: number): void {
        this.page = page
        void this.load()
    }

    async load(): Promise<void> {
        const id = ++this.requestId

        this.isLoading = true
        this.error = null

        try {
            const result = await LoadDiskAdminAuditTask(this.filter, AUDIT_PAGE_SIZE, (this.page - 1) * AUDIT_PAGE_SIZE)

            runInAction(() => {
                if (id !== this.requestId) return
                this.items = result.items
                this.total = result.total
            })
        } catch (error) {
            runInAction(() => {
                if (id === this.requestId) this.error = serverMessage(error, 'Не вдалося завантажити журнал')
            })
        } finally {
            runInAction(() => {
                if (id === this.requestId) this.isLoading = false
            })
        }
    }
}

export const diskAdminAuditStore = new DiskAdminAuditStore()
